import * as React from 'react';
import { Row, Col, Button } from 'antd';
import TableFilterContextProvider from 'components/Forms/DataGrid/TableFilterContextProvider';
import { IpoApplicationListFilterBar, IpoApplicationListTable } from '.';
import { RouteComponentProps } from 'react-router-dom';
import { withRouter } from 'react-router';
import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';
import { RightAlignedRow } from 'components/Styled/Layout/RightAlignedRow';
import { LeftAlignedRow } from 'components/Styled/Layout/LeftAlignedRow';
import { CenteredContent } from '../../Layout/RegisterLayout/RegisterLayout.Style';
import { WhiteBackgroundCard } from '../../Forms/Form.Styled';

export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
}

export interface State { }

export class IpoApplicationListViewWithoutRouter extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {};
    }

    AddNewJcsdAccount = () => {
        const newDetailsData = new DetailsData();
        newDetailsData.mode = DetailsMode.New;
        this.props.history.push('accounts/wizard', newDetailsData);
    };

    render() {
        return (
            <WhiteBackgroundCard>
                <TableFilterContextProvider>
                    <Row>
                        <Col md={24}>
                            <IpoApplicationListFilterBar />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={24}>
                            <IpoApplicationListTable />
                        </Col>
                    </Row>
                </TableFilterContextProvider>
            </WhiteBackgroundCard>
        );
    }
}

const IpoApplicationListView = withRouter(IpoApplicationListViewWithoutRouter);

export default IpoApplicationListView;



